import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ConfigurationsService, GungConfiguration } from './configurations.service';

export interface ApiConfiguration {
  activated: boolean;
  batchSize: number;
  additionalEntities: ApiAdditionalEntity[];
  pushTransformers: Record<string, string>;
}

export interface ApiAdditionalEntity {
  entity: string;
  relatedMainEntity: string;
}

export interface CustomerSufix {
  suffix: string;
}

export interface ApiEntity {
  entity: string;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class GungSettingsApiService {

  constructor(protected http: HttpClient, protected configurationsService: ConfigurationsService) { }

  getApiConfigurations(): Observable<GungConfiguration>{
    return this.configurationsService.getConfigurationsByIds(['ApiConfiguration']).pipe(map(config =>{
      return config[0] as GungConfiguration;
    }));
  }

  saveApiConfigurations(config: GungConfiguration): Observable<GungConfiguration>{
    return this.configurationsService.updateConfiguration(config)
  }

  getCustomerSufix(): Observable<CustomerSufix>{
    const url = `json/api/customer-suffix`;
    return this.http.get<CustomerSufix>(url);
  }

  getApiEntities(): Observable<ApiEntity[]>{
    const url = `json/api/entities`;
    return this.http.get<ApiEntity[]>(url);
  }
}
